import React, { useEffect, useState } from 'react'

import { Button } from '@Components/Button'
import { useClub } from '@Domains/Club/Hook'
import { useTranslation } from '@Globals/Translations'

import styles from './styles.module.scss'

export const ClubVerifyEmail = () => {
  const { check, defaultEmail, setModalState, verifyEmail } = useClub()
  const { t, tDanger } = useTranslation()
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    const verifyEmailAsync = async () => {
      if (defaultEmail) {
        const errorString = await verifyEmail(defaultEmail)
        if (errorString) {
          console.error('handle error', errorString)
          return
        }
      }

      // TODO: ensure we ask for email if none is provided, so we can verify it
    }

    verifyEmailAsync()
  }, [defaultEmail, verifyEmail])

  return (
    <form
      onSubmit={async (e) => {
        e.preventDefault()
        e.stopPropagation()

        const result = await check({ email: defaultEmail })
        if (!result) {
          setError('unknown error')
          return
        }

        if (result.nextModalState === 'VERIFY_EMAIL') {
          setError('common:TRENDHIMCLUB_ACCOUNT_NOT_VERIFIED_ERROR')
          return
        }

        if (result.nextModalState === 'SIGN_IN') {
          setError(null)

          setModalState((prev) => {
            if (prev !== 'VERIFY_EMAIL') {
              return prev
            }

            return result.nextModalState
          })
          return
        }

        setError('unknown error')
      }}
    >
      <p style={{ color: 'var(--black)' }}><b style={{ color: 'var(--black)' }}>{t('common:TRENDHIMCLUB_NEXT_STEP')}</b></p>
      {/* eslint-disable-next-line max-len */}
      <p style={{ color: 'var(--black)' }} {...tDanger('common:TRENDHIMCLUB_ACCOUNT_CREATION_CONFIRMATION_TEXT')} />
      {/* <button className={styles.labelButton} color="black" onClick={onResendClick} type="button">{t('NEXT_LABEL', 'Resend email')}</button> */}
      <Button autoFocus className={styles.nextButton} color="black" type="submit">{t('common:LOGIN_LABEL')}</Button>
      {error && <p className={styles.error}>{t(error)}</p>}
    </form>
  )
}
